import { AxiosResponse } from 'axios'
import FindByIdRequest from 'modules/lotes/domain/entities/FindByIdRequest'
import FindByIdResponse from 'modules/lotes/domain/entities/FindByIdResponse'
import { ICancelarViagemResponse } from 'modules/lotes/domain/entities/ICancelarViagemResponse'
import ICancelaViagem from 'modules/lotes/domain/entities/ICancelaViagem'
import IDirecionarCargasRequest from 'modules/lotes/domain/entities/IDirecionarCargasRequest'
import IDirecionarCargasResponse from 'modules/lotes/domain/entities/IDirecionarCargasResponse'
import { IFinalizarViagemResponse } from 'modules/lotes/domain/entities/IFinalizarViagemResponse'
import IFinalizaViagem from 'modules/lotes/domain/entities/IFinalizaViagem'
import IProduto from 'modules/lotes/domain/entities/IProduto'
import IValidateCaminhaoDTO from 'modules/lotes/domain/entities/IValidateCaminhaoDTO'
import IValidateCaminhaoResponse from 'modules/lotes/domain/entities/IValidateCaminhaoResponse'
import IValidateMotoristaDTO from 'modules/lotes/domain/entities/IValidateMotoristaDTO'
import IValidateMotoristaResponse from 'modules/lotes/domain/entities/IValidateMotoristaResponse'
import ILoteRequest from 'modules/lotes/domain/entities/LoteRequest'
import ILoteResponse from 'modules/lotes/domain/entities/LoteResponse'
import IVerificaCargaDisponivelResponse from 'modules/lotes/domain/entities/VerificaCargaDisponivelResponse'

import { ServiceConfig } from '../../../../shared/services/ServiceConfig'
import { ILoteRepository } from '../../domain/repositories/ILoteRepository'

const http = new ServiceConfig()
export default class LoteRepository implements ILoteRepository {
  async validateLoteQuarteirizado(idLote: number): Promise<boolean> {
    const response: AxiosResponse<boolean> = await http.get(
      `/lotes/lote-quarteirizado/${idLote}`,
    )
    return response.data
  }

  async direcionarCargas(
    params: IDirecionarCargasRequest,
  ): Promise<IDirecionarCargasResponse> {
    const response: AxiosResponse<IDirecionarCargasResponse> = await http.post(
      '/direcionar/cargas',
      params,
    )
    return response
  }

  public async findAll(params: ILoteRequest): Promise<ILoteResponse> {
    const {
      page,
      id,
      origem,
      destino,
      valor,
      raio_origem,
      raio_destino,
      produto_id,
      lotes_direcionados,
      cnpj_frotista,
    } = params

    const response: AxiosResponse<ILoteResponse> = await http.get('/lotes', {
      params: {
        page,
        per_page: 15,
        id,
        valor,
        origem,
        destino,
        raio_origem,
        raio_destino,
        produto_id,
        lotes_direcionados,
        cnpj_frotista,
      },
    })

    return response.data
  }

  public async verificaCargaDisponivel(
    id: number,
  ): Promise<IVerificaCargaDisponivelResponse> {
    const response: AxiosResponse<IVerificaCargaDisponivelResponse> =
      await http.get('/validates/cargas', {
        params: {
          lote_id: id,
        },
      })

    return response.data
  }

  public async findById(params: FindByIdRequest): Promise<FindByIdResponse> {
    const response: AxiosResponse<FindByIdResponse> = await http.get(
      `/lotes/${params.id}`,
    )

    if (response.data.origem?.includes('null - null')) {
      response.data.origem = null
    }
    if (response.data.destino?.includes('null - null')) {
      response.data.destino = null
    }
    return response.data
  }

  public async findAllProdutos(): Promise<IProduto[]> {
    const response: AxiosResponse<IProduto[]> = await http.get(
      '/lotes/produtos',
    )
    return response.data
  }

  async validateMotorista(
    params: IValidateMotoristaDTO,
  ): Promise<IValidateMotoristaResponse> {
    const queryParams = new URLSearchParams()
    queryParams.append('cpf', params.cpf)

    const response: AxiosResponse<IValidateMotoristaResponse> = await http.get(
      `/validates/motoristas?${queryParams.toString()}`,
    )
    return response.data
  }

  async validateCaminhao(
    params: IValidateCaminhaoDTO,
  ): Promise<IValidateCaminhaoResponse> {
    const queryParams = new URLSearchParams()
    queryParams.append('placa', params.placa)

    const response: AxiosResponse<IValidateCaminhaoResponse> = await http.get(
      `/validates/caminhao?${queryParams.toString()}`,
    )
    return response.data
  }

  async finalizaViagem(
    params: IFinalizaViagem,
  ): Promise<IFinalizarViagemResponse> {
    const { status } = await http.patch(
      `/finalizar/viagem?lote_conjunto_id=${params.lote_conjunto_id}`,
    )
    return { status }
  }

  async cancelaViagem(
    params: ICancelaViagem,
  ): Promise<ICancelarViagemResponse> {
    const { status } = await http.patch(
      `/cancelar/viagem?lote_conjunto_id=${params.lote_conjunto_id}`,
    )
    return { status }
  }
}
